<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div>
    <a-form class="login-form">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="帐号"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ updeUserInfo.account || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="审核时间"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ updateTime || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="帐号状态"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-tag v-if="updeUserInfo.auditStatus == 1" color="orange">
              未认证
            </a-tag>
            <a-tag v-if="updeUserInfo.auditStatus == 2" color="blue">
              审核中
            </a-tag>
            <a-tag v-if="updeUserInfo.auditStatus == 3" color="green">
              已认证
            </a-tag>
            <a-tag v-if="updeUserInfo.auditStatus == 4" color="red">
              审核不通过
            </a-tag>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="updeUserInfo.auditStatus == 4">
          <a-form-item
            class="mb-5"
            label="审核不通过理由"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ remark || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="营业执照"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <img
              style="height: 120px"
              v-if="businessLicense"
              :src="businessLicense"
              alt="营业执照"
            />
            <div v-else>--</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="统一社会信用码"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ creditCode || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="公司名称"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ companyName || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="法人名称"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ legalName || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="法人身份证"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ legalCardNumber || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="公司地址"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ companyAddress || "--" }}</div>
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item style="display: flex; justify-content: center">
        <a-button type="primary" @click="showEditModal">{{updeUserInfo.auditStatus!==3?'修改认证资料':'开始实名认证'}}</a-button>
      </a-form-item>
    </a-form>

    <!-- 修改资料的 Modal -->
    <a-modal
      title="修改公司资料"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      width="800px"
    >
      <a-form :form="form">
        <a-alert message="修改资料后，需要重新审核，请耐心等待审核结果" type="warning" show-icon style="margin-bottom: 25px"/>
        <a-form-item label="营业执照" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-upload
            :before-upload="beforeUpload"
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            action=""
            @change="handleChange"
          >
            <img
              style="height: 120px"
              v-if="editData.businessLicense"
              :src="editData.businessLicense"
              alt="avatar"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">点击上传</div>
            </div>
          </a-upload>
        </a-form-item>

        <a-form-item label="统一社会信用码" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-input
            v-decorator="[
              'creditCode',
              {
                initialValue: editData.creditCode,
                rules: [{ required: true, message: '请输入统一社会信用码!' }]
              }
            ]"
            placeholder="请输入统一社会信用码/注册号/组织机构代码"
          />
        </a-form-item>

        <a-form-item label="公司名称" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-input
            v-decorator="[
              'companyName',
              {
                initialValue: editData.companyName,
                rules: [{ required: true, message: '请输入公司名称!' }]
              }
            ]"
            placeholder="请输入公司名称"
          />
        </a-form-item>

        <a-form-item label="法人名称" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-input
            v-decorator="[
              'legalName',
              {
                initialValue: editData.legalName,
                rules: [{ required: true, message: '请输入法人名称!' }]
              }
            ]"
            placeholder="请输入法人名称"
          />
        </a-form-item>

        <a-form-item label="法人身份证" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-input
            v-decorator="[
              'legalCardNumber',
              {
                initialValue: editData.legalCardNumber,
                rules: [{ required: true, message: '请输入法人身份证!' }]
              }
            ]"
            placeholder="请输入法人身份证"
          />
        </a-form-item>

        <a-form-item label="公司地址" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-textarea
            v-decorator="[
              'companyAddress',
              {
                initialValue: editData.companyAddress,
                rules: [{ required: true, message: '请输入公司地址!' }]
              }
            ]"
            placeholder="请输入公司地址"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {
  getUserAuditStatus,
  uploadDynamicReturnUrl,
  companyAdd,
} from "@/api/user";
import { message } from "ant-design-vue";

const formItemLayout = {
  labelCol: { span: 12 },
  wrapperCol: { span: 12 },
};

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      updeUserInfo: {},
      formItemLayout,
      loading: false,
      creditCode: "",
      updateTime:'',
      companyName: "", //公司名称
      legalName: "", //
      legalCardNumber: "",
      companyAddress: "",
      businessLicense: "",
      remark: "",
      // 编辑时的临时数据
      editData: {
        creditCode: "",
        companyName: "",
        legalName: "",
        legalCardNumber: "",
        companyAddress: "",
        businessLicense: "",
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'edit_company_form' });
  },
  created() {
    this.updeUserInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    this.getUserAuditStatus();
  },
  methods: {
    getUserAuditStatus() {

      getUserAuditStatus({ id: this.updeUserInfo.companyId }).then((res) => {
        this.creditCode = res.creditCode;
        this.companyName = res.companyName;
        this.legalName = res.legalName;
        this.legalCardNumber = res.legalCardNumber;
        this.companyAddress = res.companyAddress;
        this.businessLicense = res.businessLicense;
        this.remark = res.remark;
        this.updateTime = res.updateTime;

        // 同时更新编辑数据
        this.editData = {
          creditCode: res.creditCode,
          companyName: res.companyName,
          legalName: res.legalName,
          legalCardNumber: res.legalCardNumber,
          companyAddress: res.companyAddress,
          businessLicense: res.businessLicense,
        };
      });
    },

    showEditModal() {
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
      this.form.resetFields();
    },

    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true;
          
          // 添加必要的字段
          const submitData = {
            ...values,
            businessLicense: this.editData.businessLicense,
            id: this.updeUserInfo.companyId,
          };

          companyAdd(submitData)
            .then(res => {
              if (res) {
                message.success('提交成功,请等待审核');
                this.visible = false;
                this.getUserAuditStatus(); // 刷新数据
              } else {
                message.error(res.msg || '提交失败');
              }
            })
            .catch(error => {
              message.error('提交失败');
              console.error(error);
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    },

    handleChange(info) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", info.file);

      uploadDynamicReturnUrl(formData)
        .then((res) => {
          this.loading = false;
          this.editData.businessLicense = res;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    beforeUpload(file) {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("只能上传 JPG/PNG 格式的图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("图片必须小于 2MB!");
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-uploader {
  :deep(.ant-upload) {
    width: 128px;
    height: 128px;
    border-radius: 4px !important;
  }

  :deep(.ant-upload.ant-upload-select-picture-card) {
    width: 128px;
    height: 128px;
    border-radius: 4px !important;
  }
}

:deep(.ant-upload-select-picture-card) {
  width: 128px !important;
  height: 128px !important;
  border-radius: 4px !important;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

:deep(.ant-upload-list-picture-card .ant-upload-list-item) {
  width: 128px;
  height: 128px;
  border-radius: 4px !important;
}
</style>
